
















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import {
    CancelToken,
    Distance,
    TransportLoad,
    TransportLoadTransportPartModel
} from "../models";

import { distanceService } from "@/services";

import PlanTaskDialogLoadTask from "./PlanTaskDialogLoadTask.vue";
import VehicleCalendar from "./VehicleCalendar.vue";
import VehicleSelectDialog from "./VehicleSelectDialog.vue";

@Component({
    components: {
        PlanTaskDialogLoadTask,
        VehicleCalendar,
        VehicleSelectDialog
    }
})
export default class PlanTaskDistanceDialog extends Vue {
    @Prop() defaults: any;

    start = "";
    end = "";

    headers: any = null;
    cancelToken: any = null;

    results: Distance[] | null = null;

    mounted(): void {
        this.headers = [
            {
                text: this.$t("planTaskDistanceDialog.start"),
                value: "startPostNumber"
            },
            {
                text: "",
                value: "startPlace"
            },
            {
                text: this.$t("planTaskDistanceDialog.end"),
                value: "endPostNumber"
            },
            {
                text: "",
                value: "endPlace"
            },
            {
                text: this.$t("planTaskDistanceDialog.distance"),
                value: "kilometers"
            },
            {
                text: this.$t("planTaskDistanceDialog.notes"),
                value: "notes"
            }
        ];
        if (this.defaults) {
            this.start = this.defaults.start;
            this.end = this.defaults.end;
        }
        this.$watch("start", this.search);
        this.$watch("end", this.search);
        this.search();
    }

    async search(): Promise<void> {
        if (this.cancelToken) {
            this.cancelToken();
            this.cancelToken = null;
        }
        if (!this.start.length || !this.end.length) {
            this.results = null;
            return;
        }
        const data = await distanceService.searchDistances(this.start, this.end, undefined, undefined, new CancelToken((c) => { this.cancelToken = c; }));
        this.results = data.items;
        this.cancelToken = null;
    }

    select(distance: Distance): void {
        this.$emit("input", distance);
        this.$emit("close");
    }
}
